
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
//@ts-ignore
import Sprite from "@/assets/icons/sprite.svg";

@Component
export default class Icon extends Vue {
  sprite: any = Sprite;
  @Prop({ default: "#cccccc" }) readonly color?: string;
  @Prop({ default: "24px" }) readonly size?: string;
  @Prop({ default: "0 0 64 64" }) readonly viewBox?: string;
  @Prop() readonly type!: string;
  get spritepath() {
    return `${Sprite}#${this.type}`;
  }
}
